<template>
  <div ref="container"></div>
</template>

<script lang="ts" setup>
interface IProps {
  html: any;
}
import { ref, watch, onMounted } from 'vue'
const props = defineProps<IProps>();
const container = ref<HTMLElement | null>(null);
watch(
  () => props.html,
  (newHtml) => {
    if (container.value) {
      container.value.innerHTML = newHtml;
    }
  }
);
onMounted(() => {
  if (container.value) {
    container.value.innerHTML = props.html;
  }
});
</script>
